



import Component from 'vue-class-component';
import Vue from 'vue';
import authApi from '@/api/auth.api';
import authService from '@/services/auth.service';

@Component({})
export default class RemoteLoginPage extends Vue {
    public created() {
        const token = this.$route.query.token;
        if (!token) {
            this.$router.push('/login');
            return;
        }
        authService.clear(); // clear token (for resolve bug with token expired error)
        authApi.loginRemote({ token }).then((res: { token: string }) => {
            authService.processLoginSuccess(this.$store, res.token);
            this.$router.push('/app/home');
        });
    }
}
